import AggregationWidget from "views/logic/aggregationbuilder/AggregationWidget";
import ExportAggregationWidgetActionComponent from "search/ExportWidgetAction/ExportAggregationWidgetActionComponent";
const ExportAggregationWidgetAction = {
  type: "export-aggregation-widget-action",
  position: "menu",
  isHidden: (w) => w.type !== AggregationWidget.type,
  component: ExportAggregationWidgetActionComponent
};
export default ExportAggregationWidgetAction;
